import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Close from '../Close';

const ClosableTagContainer = styled.span`
  display: inline-block;
  height: auto;
  border-radius: 3px;
  font-size: 14px;

  
  ${({ theme }) => css`
    padding: ${theme.spacing[2]};
    border: 1px solid ${theme.colors.shades[5]};
    background-color: ${theme.colors.shades[7]};
  `};

  &:hover {
    background-color: #f9f9f9;
    ${({ theme }) => css`
      border: 1px solid ${theme.colors.shades[5]};
    `};
    
  }
`;

const ClosableTagContent = styled.span`
  display: inline-block;
   vertical-align: middle;
`;

function ClosableTag(props) {
  return (
    <ClosableTagContainer {...props.attrs.container} data-qa={props.qa}>
      <ClosableTagContent {...props.attrs.content}>{props.children}</ClosableTagContent>
      <Close
        {...props.attrs.closeIcon}
        onClose={props.onCloseClick}
      />
    </ClosableTagContainer>
  );
}

ClosableTag.displayName = 'ClosableTag';

ClosableTag.propTypes = {
  attrs: PropTypes.shape({
    container: PropTypes.shape({}),
    content: PropTypes.shape({}),
    closeIcon: PropTypes.shape({})
  }),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]).isRequired,
  qa: PropTypes.string,
  onCloseClick: PropTypes.func
};

ClosableTag.defaultProps = {
  attrs: {
    container: {},
    content: {},
    closeIcon: {}
  },
  onCloseClick: () => {},
  qa: undefined
};

export default ClosableTag;
